const helper = {
  getActiveParam: (state) => {
    if (state.query.active === 'all') {
      return '';
    } else if (state.query.active === 'true') {
      return 'active: true';
    }
    return 'active: false';
  },
  createInputParam: (obj, key, quote) => {
    if (obj[key] === null || typeof obj[key] === 'undefined') {
      return '';
    }
    if (typeof quote !== 'boolean') {
      quote = typeof obj[key] === 'string'; // eslint-disable-line
    }
    return quote ? `${key}: "${obj[key]}"` : `${key}: ${obj[key]}`;
  },
  stringify(objFromJson) {
    if (typeof objFromJson !== 'object' || Array.isArray(objFromJson)) {
      // not an object, stringify using native function
      return JSON.stringify(objFromJson);
    }
    // Implements recursive object serialization according to JSON spec
    // but without quotes around the keys.
    const props = Object
      .keys(objFromJson)
      .map(key => `${key}:${helper.stringify(objFromJson[key])}`)
      .join(',');
    return `{${props}}`;
  },
};

export default helper;



// WEBPACK FOOTER //
// ./src/store/helper.js